import { red, green, lightBlue, orange } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';

import NationalWeb from '../assets/fonts/NationalWeb-Regular.woff2';
import MetricWebBold from '../assets/fonts/MetricWeb-Bold.woff2';

import { allevaSlateColor, allevaOrangeColor } from '../md/assets/jss/material-dashboard-pro-react';

const allevaOrange = allevaOrangeColor[0];
const allevaPurple = '#8769ff';

const NationalWebUrl = `url(${NationalWeb})`;
const MetricWebBoldUrl = `url(${MetricWebBold})`;

const v5Theme = {
  palette: {
    primary: {
      // main: '#556cd6',
      main: allevaOrange,
    },
    secondary: {
      // main: '#19857b',
      main: allevaPurple,
    },
    slate: {
      main: allevaSlateColor,
    },
    // The next three were copied from https://mui.com/guides/migration-v4/#themeprovider-setup
    success: {
      main: green[800],
      light: green[500],
      dark: green[900],
    },
    info: {
      main: lightBlue[700],
      light: lightBlue[500],
      dark: lightBlue[900],
    },
    warning: {
      main: '#ED6C02',
      light: orange[500],
      dark: orange[900],
    },
    error: {
      main: red.A400,
    },
  },
  typography: {
    fontFamily: 'NationalWeb, MetricWebBold, Arial, sans-serif',
    fontSize: 16,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'NationalWeb';
          font-style: normal;
          font-display: swap;
          font-weight: 400;
          src: local('NationalWeb'), local('NationalWeb-Regular'), ${NationalWebUrl} format('woff2');
          unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
        }

        @font-face {
          font-family: 'MetricWebBold';
          font-style: normal;
          font-display: swap;
          font-weight: 400;
          src: local('MetricWebBold'), local('MetricWeb-Bold'), ${MetricWebBoldUrl} format('woff2');
          unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
        }
      `,
    },
    MuiButton: {
      styleOverrides: {
        root: {
          color: 'black',
        },
      },
    },
  },
};

const theme = createTheme(v5Theme);

export default theme;

/*
 */
